// src/components/InvoicePreview.js

import React from 'react';

// Helper to format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount);
};

// This is a "dumb" component. It just receives data (props) and displays it.
// All the logic and state lives in the parent InvoiceCreator component.
const InvoicePreview = ({ jeweller, customer, invoiceData, financials }) => {
  
  // Determine the customer name to display, handling cases where it might be in different places.
  const customerName = customer?.name || 'Example Customer';
  const jewellerName = jeweller?.businessName || 'Your Business Name'; // Use a fallback

  return (
    <div className="bg-white border rounded-lg shadow-sm p-8 font-sans text-gray-800">
      {/* --- Invoice Header --- */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">INVOICE</h1>
          <p className="text-gray-500">
            Invoice #: {invoiceData.uniqueRefNumber || 'DRAFT-001'}
          </p>
        </div>
        <div className="text-right">
          <h2 className="text-xl font-semibold">{jewellerName}</h2>
          {/* You can add more jeweller details here if available */}
        </div>
      </div>

      {/* --- Bill To and Dates --- */}
      <div className="grid grid-cols-2 gap-4 mb-10">
        <div>
          <p className="font-semibold text-gray-600 mb-1">Bill To</p>
          <p className="font-medium text-gray-900">{customerName}</p>
          <p className="text-gray-700">{customer?.email || 'customer@email.com'}</p>
        </div>
        <div className="text-right">
          <div className="mb-2">
            <p className="font-semibold text-gray-600">Date of Issue</p>
            <p className="text-gray-700">{new Date().toLocaleDateString('en-GB')}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-600">Date Due</p>
            <p className="text-gray-700">
              {invoiceData.dueDate ? new Date(invoiceData.dueDate + 'T00:00:00').toLocaleDateString('en-GB') : 'Not set'}
            </p>
          </div>
        </div>
      </div>

      <div className="text-sm text-gray-600 mb-4 italic">
        Invoice from {jeweller.companyName} via Boutee
        </div>

      {/* --- Line Items Table --- */}
      <table className="w-full text-left mb-8">
        <thead>
          <tr className="bg-gray-100 text-gray-600 text-sm uppercase">
            <th className="p-3 font-semibold">Description</th>
            <th className="p-3 font-semibold text-center">Qty</th>
            <th className="p-3 font-semibold text-right">Unit Price</th>
            <th className="p-3 font-semibold text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          {invoiceData.lineItems.map((item, index) => (
            <tr key={index} className="border-b">
              <td className="p-3">{item.description || 'Item description'}</td>
              <td className="p-3 text-center">{item.quantity}</td>
              <td className="p-3 text-right">{formatCurrency(item.price)}</td>
              <td className="p-3 text-right font-medium">{formatCurrency(item.quantity * item.price)}</td>
            </tr>
          ))}
          {invoiceData.lineItems.length === 0 && (
             <tr>
                <td colSpan="4" className="text-center p-4 text-gray-500">No items added yet.</td>
             </tr>
          )}
        </tbody>
      </table>

      {/* --- Totals Section --- */}
      {/* --- CORRECTED Totals Section --- */}
      {/* This now only shows what the customer needs to see. */}
      <div className="flex justify-end">
        <div className="w-full max-w-xs text-gray-700">
          <div className="flex justify-between mb-2">
            <span>Subtotal</span>
            <span>{formatCurrency(financials.subtotal)}</span>
          </div>
          {/* The commission line has been REMOVED from the customer preview */}
          <div className="border-t my-2"></div>
          <div className="flex justify-between font-bold text-gray-900 text-xl">
            <span>Amount Due</span>
            {/* The Amount Due is the same as the subtotal */}
            <span>{formatCurrency(financials.subtotal)}</span>
          </div>
        </div>
      </div>

    </div> // This closes the main div of the component
  );
};

export default InvoicePreview;